import React, { useState } from 'react';
import Popup from '../Popup';
import TextField from '../TextField';
import useApi from '../../hooks/useApi';

import { Container, Wrapper, TextBlock } from './styles';

const LoopRemixPopup = ({ popupIsOpen, userToken, flash, onClose, loopId, defaultName, onSuccess }) => {
  const { postData, loading } = useApi(userToken);
  const [name, setName] = useState(i18n.__('circle_remix_name_default', defaultName));
  const [disableButton, setDisableButton] = useState(false);

  const handleSave = async () => {
    const result = await postData(`/library/adapt/${loopId}`, {
      name,
    });

    if (result.success) {
      setDisableButton(true);
      const id = result.body.id;
      window.location.replace(`/editor/${id}`);
    } else {
      flash(i18n.__('app_error_alert'));
    }
  };

  const contentPanel = (
    <Container>
      <Wrapper>
        <TextBlock dangerouslySetInnerHTML={{ __html: i18n.__('circle_remix_body') }} />
        <>
          <TextField
            autoFocus
            id="name"
            name="name"
            label={i18n.__('circle_remix_name_label')}
            defaultValue={name}
            onChange={(event) => {
              setName(event.target.value);
            }}
          />
        </>
      </Wrapper>
    </Container>
  );

  return (
    <Popup
      popupIsOpen={popupIsOpen}
      heading={i18n.__('circle_remix_header')}
      id="loop-remix-popup"
      width={675}
      contentPanel={contentPanel}
      buttonLabel={i18n.__('circle_remix_action')}
      onClose={onClose}
      onClick={handleSave}
      buttonDisabled={name.trim() === '' || loading || disableButton}
    />
  );
};

export default LoopRemixPopup;
